var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2857 11.6042C13.2857 11.9081 13.1615 12.1995 12.9405 12.4144C12.7195 12.6293 12.4197 12.75 12.1071 12.75H2.67857C2.36599 12.75 2.06622 12.6293 1.8452 12.4144C1.62417 12.1995 1.5 11.9081 1.5 11.6042V3.58333C1.5 3.27944 1.62417 2.98799 1.8452 2.77311C2.06622 2.55822 2.36599 2.4375 2.67857 2.4375H5.625L6.80357 4.15625H12.1071C12.4197 4.15625 12.7195 4.27697 12.9405 4.49186C13.1615 4.70674 13.2857 4.99819 13.2857 5.30208V11.6042Z",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.4167C4.5 14.7206 4.62417 15.012 4.8452 15.2269C5.06622 15.4418 5.36599 15.5625 5.67857 15.5625H15.1071C15.4197 15.5625 15.7195 15.4418 15.9405 15.2269C16.1615 15.012 16.2857 14.7206 16.2857 14.4167V8.11458C16.2857 7.81069 16.1615 7.51924 15.9405 7.30436C15.7195 7.08947 15.4197 6.96875 15.1071 6.96875",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupCopy);
export default __webpack_public_path__ + "static/media/groupCopy.dcf444b787472c8b6357b6d97e8a769f.svg";
export { ForwardRef as ReactComponent };